module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "page content",
    class: !_vm.loading ? '' : 'loading'
  }, [(_vm.post) ? _c('div', [(_vm.post.postType === 'episode') ? _c('episode', {
    attrs: {
      "episode": _vm.post
    }
  }) : _vm._e(), _vm._v(" "), (_vm.post.postType === 'extra') ? _c('extra', {
    attrs: {
      "extra": _vm.post
    }
  }) : _vm._e(), _vm._v(" "), (_vm.post.postType === 'page') ? _c('page', {
    attrs: {
      "page": _vm.post
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fda11e40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Preview.vue
// module id = 807
// module chunks = 1